import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { RcsAppConfig } from '../../assets/app.config';

import { IndexedDBAngular } from 'indexeddb-angular';
import {AsyncSubject} from "rxjs";

@Injectable()
export class RcsStackDbProvider{

  private datenbank: IndexedDBAngular;

  constructor(public http: Http, private app_conf: RcsAppConfig) {
    this.datenbank = new IndexedDBAngular('RCS_' + this.app_conf.db_prefix + '_Stack', 1);
    this.datenbank.createStore(1, (evt) => {
      //let object_store = evt.currentTarget.result.createObjectStore('stack', { keyPath: "id"});
      let object_store = evt.currentTarget.result.createObjectStore('stack');
      object_store.createIndex("id", "_id", { unique: false });
    });
  }

  // Fügt einen Task zur Datenbank hinzu
  public add_tasks_to_stack(task: any):void{
  console.log(task);
    let observable = Observable.fromPromise(this.datenbank.getByKey('stack', task.module_id));
    observable.subscribe(
      result => {
        if (result){
          //this.datenbank.update('stack', { task: task, _id: task._id }, task.module_id);
        }else{
          this.datenbank.add('stack', { task: task, _id: task._id }, task.module_id);
        }
      }, error => { console.log('test_3', error) }
    )
  }

  // Fügt einen Task hinzu
  public add(value: any, key: any){
    const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Stack', 1);
    return Observable.create(observer => {
      DBOpenRequest.onsuccess = function(event){
        const database = DBOpenRequest.result;
        const transaction = database.transaction('stack', 'readwrite').objectStore('stack');
        const request = transaction.put(value, key);
        request.onsuccess = function(){ observer.next() },
          request.onerror = function (){ observer.error() }
        transaction.oncomplete = function(){ observer.complete() }
      }
    })
  }

  public update(value: any, key: any){
    const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Stack', 1);
    return Observable.create(observer => {
      DBOpenRequest.onsuccess = function(event){
        const database = DBOpenRequest.result;
        const transaction = database.transaction('stack', 'readwrite').objectStore('stack');
        const update = transaction.put(value, key);
        update.onsuccess = function() {
          observer.next()
          observer.complete()
        };
      }
    })
  }

  //Gibt einen Task anhand seines Keys zurück
  public search(collection: string, key: number): AsyncSubject<any>{
    const item_observer = new AsyncSubject();
    const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Stack', 1);
    DBOpenRequest.onsuccess = function(){
      const database = DBOpenRequest.result;
      const object_store = database.transaction(collection, 'readonly').objectStore(collection);
      const request = object_store.get(key);
      request.onsuccess = function(event){
        item_observer.next(event.target.result);
        item_observer.complete();
      }
    }
    return item_observer;
  }

  // Gibt alle Tasks aus der Datenbank zurück
  public get_tasks(): AsyncSubject<any>{
    const item_observer = new AsyncSubject();
    const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Stack', 1);
    DBOpenRequest.onsuccess = function(event){
      const database = DBOpenRequest.result;
      const object_store = database.transaction('stack', 'readonly').objectStore('stack');
      const request = object_store.getAll();
      request.onsuccess = function(event){
        item_observer.next(event.target.result);
        item_observer.complete();
      }
    }
    return item_observer;
  }

  // Überwacht die Datenbank auf neue Einträge
  public stack_guardian(intervall){
    let database = this.datenbank;
    return new Observable(observer => {
      setInterval(function(){
        let elements_length = 0;
        database.getAll('stack').then(
          (elements) => {
            if (elements_length !== elements.length || elements_length != 0){
              elements_length = elements.lenght;
              observer.next(elements);
            }
        });
      }, intervall);
    })
  }

  // Überwacht bestimmte Tasks und informiert, wenn Tasks beendet sind
  public overwatch_index(task_id:number):Observable<any>{
    let database = this.datenbank;
    return new Observable(observer => {
      let interval = setInterval(function(){
        database.getByIndex('stack', 'id', task_id).then(
          (result) => {
            if (typeof(result) === 'undefined'){
              observer.next(true);
              observer.complete();
              clearInterval(interval);
            }
          });
      }, 2500);
    })
  }

  public get_stack_ids(){
    const item_observer = new AsyncSubject();
    const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Stack', 1)
    DBOpenRequest.onsuccess = function(){
      const database = DBOpenRequest.result
      const object_store = database.transaction('stack', 'readonly').objectStore('stack')
      const keys = object_store.getAllKeys()
      keys.onsuccess = function() {
        item_observer.next(keys.result)
        item_observer.complete()
      }
    }
    return item_observer;
  }

  // Updatet einen Datensatz in der Datenbank
  public update_record(store, fields){
    return this.datenbank.update(store, fields);
  }

  // Entfernt einen Task aus der Datenbank
  public remove_stack_item(id){
    console.log('remove_new')
    return this.datenbank.delete('stack', id);
  }

}



// WEBPACK FOOTER //
// ./src/providers/rcs-stack-db-service/rcs-stack-db-service.ts